module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '    <div class="vertical-line"></div>\n    <button href="#" class="button btn"></button>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/ExperienceTemplateOptionsView.tpl
// module id = 2945
// module chunks = 0